import { MutationTree, ActionTree } from 'vuex';
import { conferencingMutations, conferencingActions, getDefaultConferencingState } from 'fourwaves-shared';
import { RootState, ConferencingState } from '~/types';

export const state = (): ConferencingState => getDefaultConferencingState();

export const mutations: MutationTree<ConferencingState> = {
  ...conferencingMutations,
};

export const actions: ActionTree<ConferencingState, RootState> = {
  ...conferencingActions,
};
